var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgShoes(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 14,
    viewBox: "0 0 24 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.5001 10L22.5 12C22.5 12.2762 22.2761 12.5 22 12.5H2.49997C2.22382 12.5 1.99995 12.2762 1.99997 12.0001C2 11.4345 2.00004 10.5241 2.00004 10M22.5001 10C22.5001 7 20.5002 5.5 17.0002 5C14.152 4.59312 12.6283 2.53068 11.8902 1.50717C11.6999 1.24334 11.3351 1.26882 11.1313 1.52231C10.438 2.38443 9.13615 3.5 7.49988 3.5C5.85038 3.5 4.88109 2.81979 4.31151 2.30087C4.12758 2.1333 3.85023 2.10904 3.66412 2.27419C1.89112 3.84756 1.0576 6.70178 2.00004 10M22.5001 10H2.00004M11.5002 5L12.7502 3.33494M14.0002 6L15.0002 4.49939",
    stroke: "#26272B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShoes);
export default __webpack_public_path__ + "static/media/shoes.a309b0c6fa637cd7c81a569e0a59d670.svg";
export { ForwardRef as ReactComponent };